var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.fieldType.subfieldtypes),function(subfieldtype){return _c('AnswerField',{key:subfieldtype.id,attrs:{"userFormId":_vm.userFormId,"question":_vm.question,"fieldType":subfieldtype,"readOnly":_vm.readOnly || false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }